import { Program } from '../types/program'

export const fetchPrograms = async (callLetter: string, day: string) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/GetLiveChannelProgramsByDate?callLetter=${callLetter}&date=${day}&userAgent=IPTV_OFR_GTV`
  )
  if (!response.ok) throw new Error('Failed to fetch channel data')
  const json = await response.json()
  return json.Result.map((channelData: any) => {
    return mapProgramDataFromAPI(channelData, day)
  })
}
export const fetchProgramSearch = async (search: string) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/Search?searchKeyword=${search}&userAgent=IPTV_OFR_GTV`
  )
  if (!response.ok) throw new Error('Failed to fetch channel data')
  const json = await response.json()
  return json.Result.map((channelData: any) => {
    return mapProgramDataFromAPI(
      channelData,
      new Date().toISOString().slice(0, 10), // just to get the date, not used in this case
      true
    )
  })
}
export const fetchOtherEpisodes = async (
  callLetter: string,
  titleId: string
) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/GetLiveChannelProgramsByTitleId?callLetter=${callLetter}&titleId=${titleId}&userAgent=IPTV_OFR_GTV​`
  )
  if (!response.ok) throw new Error('Failed to fetch channel data')
  const json = await response.json()
  return json.Result.map((channelData: any) => {
    return mapProgramDataFromAPI(
      channelData,
      new Date().toISOString().slice(0, 10) // just to get the date, not used in this case
    )
  })
}
export const fetchOtherSchedules = async (programId: string) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/GetProgramInfoByProgramId?programId=${programId}&userAgent=IPTV_OFR_GTV`
  )
  if (!response.ok) throw new Error('Failed to fetch channel data')
  const json = await response.json()
  return json.Result.map((channelData: any) => {
    return mapProgramDataFromAPI(
      channelData,
      new Date().toISOString().slice(0, 10) // just to get the date, not used in this case
    )
  })
}
export const mapProgramDataFromAPI = (
  channelData: any,
  day: string,
  noUtc: boolean = false
): Program => {
  const startDate = new Date(channelData.StartDate + (noUtc ? '' : 'Z'))
  const endDate = new Date(channelData.EndDate + (noUtc ? '' : 'Z'))

  // build the 00:00 boundary of `day` and of the next day
  const [Y, M, D] = day.split('-').map(Number)
  // Note: month is zero-based
  const dayStart = new Date(Y, M - 1, D, 0, 0, 0, 0)
  const nextDayStart = new Date(Y, M - 1, D, 0, 0, 0, 0)
  nextDayStart.setDate(nextDayStart.getDate() + 1)

  // clamp programme interval to [dayStart, nextDayStart)
  const effectiveStart = startDate < dayStart ? dayStart : startDate
  const effectiveEnd = endDate > nextDayStart ? nextDayStart : endDate

  // if there is no overlap, duration = 0
  const overlapMs = Math.max(
    0,
    effectiveEnd.getTime() - effectiveStart.getTime()
  )
  const durationInMinutes = Math.floor(overlapMs / 1000 / 60)
  const totalDurationInMinutes = Math.floor(
    (endDate.getTime() - startDate.getTime()) / 1000 / 60
  )

  const channel: Program = {
    bookmark: channelData.Bookmark,
    friendlyUrlName: channelData.FriendlyUrlName,
    availableOnChannels: channelData.AvailableOnChannels,
    callLetter: channelData.CallLetter,
    id: channelData.Id,
    imageUri: channelData.ImageUri,
    isAdultContent: channelData.IsAdultContent,
    isBlackout: channelData.IsBlackout,
    isEnabled: channelData.IsEnabled,
    isLiveAnytimeChannel: channelData.IsLiveAnytimeChannel,
    numberOfEpisodes: channelData.NumberOfEpisodes,
    programId: channelData.ProgramId,
    searchRank: channelData.SearchRank,
    seriesEpisodeNumber: channelData.SeriesEpisodeNumber,
    seriesId: channelData.SeriesId,
    synopsis: channelData.Synopsis,
    title: channelData.Title,
    titleId: channelData.TitleId,
    start: {
      utc: channelData.StartDate,
      date: startDate,
      day: startDate.toLocaleDateString('pt-PT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }),
      time: startDate.toLocaleTimeString('pt-PT', {
        hour: '2-digit',
        minute: '2-digit',
      }),
    },
    end: {
      utc: channelData.EndDate,
      date: endDate,
      day: endDate.toLocaleDateString('pt-PT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }),
      time: endDate.toLocaleTimeString('pt-PT', {
        hour: '2-digit',
        minute: '2-digit',
      }),
    },
    duration: durationInMinutes,
    totalDuration: totalDurationInMinutes,
  }
  return channel
}

export const fetchProgramInfo = async (programId: number, date: string) => {
  const response = await fetch(
    `${import.meta.env.VITE_SERVICE_URL}/Services/GridTv/GridTv.svc/GetProgramInfo?id=${programId}&userAgent=IPTV_OFR_GTV`
  )
  if (!response.ok) throw new Error('Failed to fetch program info')
  const json = await response.json()
  return mapProgramDataFromAPI(json.Result, date)
}
